let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iIfud")).then(() => parcelRequire('fi3dY'));